import React from 'react'

import { makeStyles } from '@material-ui/core/styles'
import MUIExpansionPanel from '@material-ui/core/Accordion'
import MUIExpansionPanelDetails from '@material-ui/core/AccordionDetails'
import Divider from '@material-ui/core/Divider'

import ExpansionPanelSummary from './ExpansionPanelSummary'

const styles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden', // fixes bottom border radius on opened panel
    boxShadow: theme.shadows[3],
    '&:before': {
      content: 'none'
    },
    '&:last-child': {
      marginBottom: 0
    },

    // Add margin when we are showing multiple panels
    '& + .MuiPaper-root': {
      marginTop: theme.spacing(2)
    }
  },
  contentWrapper: {
    padding: theme.spacing(2)
  },
  content: {
    width: '100%'
  },
  nested: {
    padding: 0,

    // Nested root styles
    '& .MuiAccordion-root': {
      boxShadow: theme.shadows[0],
      marginTop: 0,
      marginBottom: 0,
      borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
      borderRadius: 0,
      '&:last-of-type': {
        borderBottom: 0
      },

      '& .MuiAccordion-root': {
        borderBottom: 'none'
      },

      // Nested details styles
      '& .MuiAccordionDetails-root': {
        padding: theme.spacing(0, 1.75),
        paddingBottom: theme.spacing(0.5),

        // Nested > Nested (second level)
        '& .MuiAccordionDetails-root': {
          paddingRight: 0,
          paddingLeft: '12px'
        },

        // nested > nested (second level)
        '& .MuiAccordionSummary-root': {
          padding: 0
        }
      },

      // Styles for nested expand icon
      '& .MuiAccordionSummary-expandIcon': {
        paddingTop: '6px',
        paddingBottom: '6px'
      },

      // Nested summary styles
      '& .MuiAccordionSummary-root': {
        minHeight: '36px'
      }
    }
  }
}))

function ExpansionPanel(props) {
  const classes = styles(props)

  return (
    <MUIExpansionPanel className={classes.root} expanded={props.expanded} onChange={props.onChange}>
      <ExpansionPanelSummary
        title={props.title}
        subtitle={props.subtitle}
        icon={props.icon}
        nested={props.nested || null}
        subtitleItems={props.subtitleItems}
        iconNoBg={props.iconNoBg}
        expanded={props.expanded}
        type={props.type}
      />
      <Divider />
      <MUIExpansionPanelDetails
        className={classes.contentWrapper + ' ' + (props.nested ? classes.nested : null)}
      >
        <div className={classes.content + ' AccordionDetails-content Panel-content'}>
          {props.children}
        </div>
      </MUIExpansionPanelDetails>
    </MUIExpansionPanel>
  )
}

// Do not re-render component when its expanded props is not changed
// This fixes issue with saving state to the global context, when changing expand state in one panel would re-render all expansion panels
const areEqual = (prevProps, nextProps) => {
  return prevProps.expanded === nextProps.expanded
}

export default React.memo(ExpansionPanel, areEqual)
